<template>
  <div class="card shadow-sm h-100">
    <div class="p-4 pb-0 card-header">
      <div class="row">
        <div class="col-md-8 d-flex align-items-center">
          <h6 class="mb-0">{{ title }}</h6>
        </div>
      </div>
    </div>
    <div class="p-4 card-body">
      <ul class="list-group">
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">GTIN:</strong> &nbsp; {{ gtin14 }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">유형:</strong> &nbsp; {{ info?.category?.categoryName }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">소재명:</strong> &nbsp; {{ info.name }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">설명:</strong> &nbsp; {{ info.dsc }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">원산지:</strong> &nbsp; {{ info.originCountry?.toUpperCase() }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">유해물질 포함:</strong> &nbsp; {{ info.hazYn === 'Y' ? '예' : '아니오' }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">친환경:</strong> &nbsp; {{ info.ecoYn === 'Y' ? '예' : '아니오' }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">제조사 GTIN:</strong> &nbsp; {{ info.mfId }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: "ProfileInfoCard",
  components: {
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    gtin14() {
      return this.shortUrnToGtin14(this.info.urn);
    }
  },
};
</script>
